/*
 * Copyright (C) 2018 - 2026 Entgra (Pvt) Ltd, Inc - All Rights Reserved.
 *
 * Unauthorised copying/redistribution of this file, via any medium is strictly prohibited.
 *
 * Licensed under the Entgra Commercial License, Version 1.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       https://entgra.io/licenses/entgra-commercial/1.0
 *
 * Unless required by applicable law or agreed to in writing,
 * software distributed under the License is distributed on an
 * "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
 * KIND, either express or implied.  See the License for the
 * specific language governing permissions and limitations
 * under the License.
 */

import type { ReactNode } from 'react';
import { Center, Loader } from '@mantine/core';
import { Navigate, useLocation } from 'react-router-dom';
import { useCurrentUser } from '../features/auth/hooks';
import { usePrefetchAmiReferenceData } from '../features/registers/hooks';
import { EventStreamProvider } from '../stream/EventStreamProvider';
import { ROUTES } from './router';

export function RequireAuth({ children }: { children: ReactNode }) {
  const currentUser = useCurrentUser();
  const location = useLocation();
  usePrefetchAmiReferenceData(!!currentUser.data);

  if (currentUser.isLoading) {
    return (
      <Center style={{ height: '100vh' }}>
        <Loader />
      </Center>
    );
  }

  if (!currentUser.data) {
    return <Navigate to={ROUTES.login} replace state={{ from: location.pathname + location.search }} />;
  }

  return <EventStreamProvider>{children}</EventStreamProvider>;
}
